const dateTime = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium', timeStyle: 'short' })
const date = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium' })

export const formatDateTime = (value: Date) => dateTime.format(value)
export const formatDate = (value: Date) => date.format(value)

/** Короткое описание устройства по User-Agent без внешних библиотек. */
export function describeUserAgent(ua: string | null): string | null {
  if (!ua) return null
  const browser = /Firefox\//.test(ua)
    ? 'Firefox'
    : /Edg\//.test(ua)
      ? 'Edge'
      : /Chrome\//.test(ua)
        ? 'Chrome'
        : /Safari\//.test(ua)
          ? 'Safari'
          : null
  const os = /Windows/.test(ua)
    ? 'Windows'
    : /Mac OS X/.test(ua)
      ? /iPhone|iPad/.test(ua)
        ? 'iOS'
        : 'macOS'
      : /Android/.test(ua)
        ? 'Android'
        : /Linux/.test(ua)
          ? 'Linux'
          : null
  return [browser, os].filter(Boolean).join(', ') || ua.slice(0, 60)
}

/** Сумма с валютой по-русски: «9 000,00 ₽». Неизвестный код валюты — просто «9 000,00 XYZ». */
export function formatMoney(amount: string | number, currency: string): string {
  const n = Number(amount)
  try {
    return new Intl.NumberFormat('ru-RU', { style: 'currency', currency }).format(n)
  } catch {
    return `${n.toLocaleString('ru-RU', { maximumFractionDigits: 4 })} ${currency}`
  }
}

/** Сегодняшняя дата (ГГГГ-ММ-ДД) в часовом поясе пользователя, а не по UTC. */
export function localToday(): string {
  const d = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** «2026-09» → «сентябрь 2026». */
export function monthName(month: string): string {
  const [y, m] = month.split('-').map(Number)
  if (!y || !m) return month
  return new Intl.DateTimeFormat('ru-RU', { month: 'long', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(Date.UTC(y, m - 1, 1)))
    .replace(' г.', '')
}
